import { useCallback, useEffect, useState } from 'react';
import { fileResCommunication, TAB } from '../../type';
import { UpdateTabProps } from './index';
import { SIZE_PAGE_COMMUNICATION } from 'const/paging';
import { getUpdatesCommunication } from 'services/communication';
import { useSearchParams } from 'react-router-dom';

export const useInjection = ({ initData, dateSearch }: Partial<UpdateTabProps>) => {
  const [dataRow, setDataRow] = useState<fileResCommunication[]>([]);
  const [page, setPage] = useState<number>(1);
  const [searchParams] = useSearchParams();
  const [hasMore, setHasMore] = useState<boolean>(false);
  useEffect(() => {
    if (!initData) {
      setDataRow([]);
      return;
    }
    setDataRow(initData.updates);
    if (initData.total > SIZE_PAGE_COMMUNICATION) {
      setHasMore(true);
      setPage(2);
      return;
    }
  }, [initData, initData?.updates]);
  const [loading, setLoading] = useState(false);

  const fetchMoreData = useCallback(async () => {
    if (loading || !hasMore) return;
    setLoading(true);
    try {
      const res = await getUpdatesCommunication({
        tab: searchParams.get('tab') || TAB.UPDATES,
        page: page,
        size: SIZE_PAGE_COMMUNICATION,
        endDate: dateSearch?.endDate,
        startDate: dateSearch?.startDate
      });

      const newData = res.updates;
      setDataRow((prev) => [...prev, ...newData]);
      setHasMore(res.total > SIZE_PAGE_COMMUNICATION * page);
      setPage((prevState) => prevState + 1);
    } catch (e) {
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  }, [loading, hasMore, page, searchParams, dateSearch]);

  return {
    dataRow,
    hasMore,
    fetchMoreData,
    setDataRow
  };
};
